import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a3645410&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=a3645410&prod&lang=less&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=a3645410&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3645410",
  null
  
)

export default component.exports